export var getSimpleTitle = function getSimpleTitle(title) {
  var simpleTitle = "";
  var beginIndex = title.indexOf("<font");
  var middleIndex = title.indexOf("red>");
  var endIndex = title.indexOf("</font>");
  simpleTitle = title.substring(0, beginIndex) + title.substring(middleIndex + 4, endIndex) + title.substring(endIndex + 7);
  return simpleTitle;
};